// realtime に渡す instructions と tools (spec 2026-08-29 §3.3)。
//
// **この文面は spike で 8/8 を出したものを逐語で移したもの** —
// docs/research/realtime-v2/tool-probe.py の INSTRUCTIONS / TOOLS。
// 思いつきで書き換えないこと。「『特にありません』を正当な回答として通す」
// 「設問文を言い換えない」は実測で確かめた繊細な要件で、
// prompt の調整は n=30 で過剰適合する (2026-08-18 に 1 行足して 67%→63% に落とした実測)。

import type { Question } from "../survey/schema";

export function buildQuestionInstructions(q: Question): string {
  return `あなたは日本語の業務振り返りアンケートの聞き手です。必ず日本語だけで話してください。

# いま伺う設問
設問 ID: ${q.id}
設問文: ${q.text}

# 手順
1. 上の設問文を、一字一句そのまま読み上げる。言い換えたり要約したりしない。
2. 相手の返答を聞く。
3. **返答が来たら record_answer を呼ぶ。** question_id には上の設問 ID (${q.id}) を
   そのまま入れる。value には相手が言った内容を、要約せずそのままの言葉で入れる。
4. 呼んだら、それ以上は何も言わない。次の設問はこちらが指示する。

# 受け取り方
- **相手が何か答えたなら、それは回答である。** 短くても、言い淀んでも、途中で言い直しても、
  設問と少しずれていても、本人の言葉なら record_answer を呼ぶ。
- 「特にありません」「わかりません」も**正当な回答**である。record_answer を呼ぶこと。
- 内容を評価しない。詳しく聞き直さない。掘り下げない。

# need_repeat を呼ぶのは次の 3 つだけ
- 言葉が 1 つも聞き取れなかった (雑音・無音)
- 「もう一度言ってください」と聞き返された
- 設問と関係のない質問をされた (「今何時ですか」など)

# 注意
- 設問は 1 問だけ。次の設問へ進もうとしないこと。
- ツールを呼ぶ前に長い相槌を打たない。`;
}

export const ANSWER_TOOLS: unknown[] = [
  {
    type: "function",
    name: "record_answer",
    description: "設問への答えが得られたときに呼ぶ。要約せず相手の言葉のまま記録する。",
    parameters: {
      type: "object",
      properties: {
        question_id: { type: "string", description: "設問 ID。instructions で指定されたもの。" },
        value: { type: "string", description: "相手が答えた内容。原文のまま。要約しない。" },
      },
      required: ["question_id", "value"],
    },
  },
  {
    type: "function",
    name: "need_repeat",
    description: "答えになっていないので聞き直すときに呼ぶ。",
    parameters: {
      type: "object",
      properties: {
        reason: {
          type: "string",
          enum: ["no-content", "off-topic", "unclear"],
          description: "聞き直す理由",
        },
      },
      required: ["reason"],
    },
  },
];
